import { Flex } from 'antd';

import type { FC, ReactNode } from 'react';

interface InfoRowProps {
  label: string;
  value: ReactNode;
}

export const InfoRow: FC<InfoRowProps> = ({ label, value }) => (
  <Flex className="InfoRow" align="center" justify="space-between" gap={16}>
    <div className="InfoRow__label">{label}</div>
    <div className="InfoRow__value">{value}</div>
  </Flex>
);
